(() => {
  const pad2 = (n) => String(n).padStart(2, "0");

  function formatRemaining(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${days}D ${pad2(hours)}H ${pad2(minutes)}M ${pad2(seconds)}S`;
  }

  function tick() {
    const now = Date.now();
    document.querySelectorAll(".showcase-badge[data-showcase-end-ms]").forEach((badge) => {
      const endMs = Number(badge.dataset.showcaseEndMs);
      if (!endMs) return;

      const remaining = endMs - now;
      if (remaining <= 0) {
        badge.style.display = "none";
        return;
      }

      const timeEl = badge.querySelector(".showcase-badge__time");
      if (timeEl) timeEl.textContent = formatRemaining(remaining);
    });
  }

  function init() {
    tick();
    if (window.__showcaseCountdownInterval) clearInterval(window.__showcaseCountdownInterval);
    window.__showcaseCountdownInterval = setInterval(tick, 1000);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();